import {
  HttpClient
} from '@angular/common/http';

import {
  Injectable
} from '@angular/core';

import {
  Observable
} from 'rxjs';

import {
  environment
} from '../../environments/environment';


export interface ApplicationRequest {
  locationId: number | null;
  position: string;

  firstName: string;
  lastName: string;

  phone: string;
  email: string;

  ageEligibility: string;

  preferredShifts: string[];
  availability: string[];

  howHeard: string;
  additionalInformation: string;

  consentToContact: boolean;
}


@Injectable({
  providedIn: 'root'
})
export class ApplicationsService {

  private readonly apiUrl =
    `${environment.apiUrl}/applications`;


  constructor(
    private readonly http:
      HttpClient
  ) {}


  submitApplication(
    request: ApplicationRequest,
    resume: File | null
  ): Observable<void> {

    const formData =
      new FormData();

    formData.append(
      'locationId',
      String(request.locationId ?? '')
    );

    formData.append(
      'position',
      request.position
    );

    formData.append(
      'firstName',
      request.firstName
    );

    formData.append(
      'lastName',
      request.lastName
    );

    formData.append(
      'phone',
      request.phone
    );

    formData.append(
      'email',
      request.email
    );

    formData.append(
      'ageEligibility',
      request.ageEligibility
    );

    for (
      const shift of
      request.preferredShifts
    ) {
      formData.append(
        'preferredShifts',
        shift
      );
    }

    for (
      const availability of
      request.availability
    ) {
      formData.append(
        'availability',
        availability
      );
    }

    formData.append(
      'howHeard',
      request.howHeard
    );

    formData.append(
      'additionalInformation',
      request.additionalInformation
    );

    formData.append(
      'consentToContact',
      String(
        request.consentToContact
      )
    );

    if (resume) {
      formData.append(
        'resume',
        resume,
        resume.name
      );
    }

    return this.http.post<void>(
      this.apiUrl,
      formData
    );
  }

}